import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";
import { BackBar } from "../components/BackBar";
import { MSFormEmbed } from "../components/MSFormEmbed";

const FORM_URL = process.env.REACT_APP_MS_FORM_REGISTRATION_URL || "";
const CONTACT_EMAIL = "info@ofalycee.fr";

export default function RegisterPage() {
  const { lang } = useLang();

  const copy = lang === "fr"
    ? {
        overline: "Inscription",
        title: "Démarrez votre inscription",
        intro:
          "Remplissez le formulaire ci-dessous pour démarrer la candidature ou l'inscription de votre enfant. Notre équipe Admissions vous recontactera sous 48 h ouvrées.",
        loginPrompt: "Vous avez déjà un compte ?",
        loginCta: "Connectez-vous",
        contactSuffix: "Une question ?",
      }
    : {
        overline: "Sign up",
        title: "Start your enrollment",
        intro:
          "Fill in the form below to start your child's application or enrollment. Our Admissions team will get back to you within 48 business hours.",
        loginPrompt: "Already have an account?",
        loginCta: "Sign in",
        contactSuffix: "Got a question?",
      };

  return (
    <div className="max-w-3xl mx-auto px-6 py-10" data-testid="register-page">
      <BackBar to="/" fallbackLabelFr="Accueil" fallbackLabelEn="Home" />

      <p className="overline mb-3" data-testid="register-overline">{copy.overline}</p>
      <h1 className="font-display font-bold text-4xl lg:text-5xl tracking-tighter mb-4" data-testid="register-title">
        {copy.title}
      </h1>
      <p className="text-muted-foreground leading-relaxed mb-8" data-testid="register-intro">
        {copy.intro}
      </p>

      <MSFormEmbed
        url={FORM_URL}
        title={lang === "fr" ? "Formulaire d'inscription OFA France" : "OFA France enrollment form"}
        lang={lang}
        testId="register-form-embed"
        height={1200}
      />

      <div className="mt-10 pt-6 border-t border-border text-sm text-muted-foreground flex flex-wrap items-center justify-between gap-3">
        <span data-testid="register-login-prompt">
          {copy.loginPrompt}{" "}
          <Link to="/login" className="text-accent font-medium" data-testid="goto-login">
            {copy.loginCta}
          </Link>
        </span>
        <span>
          {copy.contactSuffix}{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-accent font-medium" data-testid="register-mailto">
            {CONTACT_EMAIL}
          </a>
        </span>
      </div>
    </div>
  );
}
